import React from 'react';
import QRCode from 'qrcode.react';
import { useApp } from '@/contexts/AppContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { QrCode } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CustomerQRCodeProps {
  customerId: string;
  customerName?: string;
  className?: string;
}

export const CustomerQRCode: React.FC<CustomerQRCodeProps> = ({ 
  customerId, 
  customerName,
  className
}) => {
  // Create a QR code value that includes the customer ID
  const qrValue = `dinetrack:${customerId}`;

  return (
    <Card className={cn("w-full max-w-md mx-auto", className)}>
      <CardHeader className="text-center">
        <CardTitle className="flex items-center justify-center gap-2">
          <QrCode className="h-6 w-6 text-restaurant-navy" />
          {customerName ? `${customerName}'s QR Code` : 'Your QR Code'}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center">
        <div className="bg-white p-4 rounded-lg shadow-inner">
          <QRCode 
            value={qrValue}
            size={250}
            level="H"
            includeMargin={true}
            className="mx-auto"
          />
        </div>
        <p className="text-sm text-muted-foreground mt-4 text-center">
          Show this QR code to the staff when you visit
        </p>
      </CardContent>
    </Card>
  );
};

export default CustomerQRCode;
